import React from 'react'
import { Divider, FlexRow } from 'components/lib'
import { SidebarSection } from '../ProfileSidebar'

const MultiHOABoardSection = () => (
  <SidebarSection>
    <Divider smMargin />
    <FlexRow align="center" justify="space-between" className="mb-2">
      <div className="text-slate-500 text-xs font-semibold uppercase leading-[18px] tracking-wide">
        BOARD TERM
      </div>
    </FlexRow>
    <FlexRow>
      <div className="w-60 text-slate-500 text-sm font-normal leading-tight">
        Select a single property to view or manage board terms.
      </div>
    </FlexRow>
  </SidebarSection>
)

export default MultiHOABoardSection
